// extracted by mini-css-extract-plugin
export var orderDetails = "_r6-2";
export var orderImage = "_r6-1";
export var orderMeta = "_r6-3";
export var orderSummary = "_r6-0";
export var rightArrow = "_r6-4";